import styled from "styled-components";

export const AccountableUsers = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;

  span {
    font-size: 0.8rem;
    font-weight: 600;
    color: #585e66;
  }
  /* div {
    svg {
      height: 1.1rem;
      margin-left: 0.3rem;
    }
  } */
`;

export const AddUser = styled.div`
  height: 1.759167rem;
  display: flex;
  align-items: center;
`;

export const AddUserTitle = styled.span`
  font-size: 0.704167rem;
  color: #42464c;
  font-weight: 600;
  line-height: 0.63rem;
  margin-left: 0.3rem;
  cursor: pointer;
`;

export const ActualUser = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  span {
    font-size: 0.75rem;
    font-weight: 600;
    color: #42464c;
    margin-left: 0.5rem;
  }
`;

export const CloseDiv = styled.div`
  svg {
    width: 0.75rem;
    height: 0.75rem;
    cursor: pointer;
    margin-left: 0.5rem;
  }

  &:hover {
    path {
      stroke: #40e5a0;
    }
  }
`;
export const Avatar = styled.img`
  width: 1.875rem;
  height: 1.875rem;
  background: lightblue;
  border-radius: 50%;
`;

export const Title = styled.span`
  font-family: Sora;
  font-style: normal;
  font-weight: 600;
  font-size: 1.125rem;
  line-height: 1.4375rem;
  color: #212326;
  margin-bottom: 1.31875rem;
`;

export const SubTitle = styled.span`
  font-family: Sora;
  font-style: normal;
  font-weight: normal;
  font-size: 1rem;
  line-height: 1.125rem;
  margin-bottom: 1.13875rem;
  margin-top: 1rem;
  color: #585e66;
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const DivIcon = styled.div`
  position: absolute;
  top: 1.125rem;
  right: 0.9375rem;
  cursor: pointer;

  svg {
    width: 0.75rem;
    height: 0.75rem;
    &:hover {
      path,
      rect {
        stroke: #40e5a0;
      }
    }
  }
`;
